export const enum GuardComponent {
  PaymentAccept,
  PaymentCancel,
  PrivateVOPage,
  PrivateDealerPage
}
